import moment from 'moment-timezone';

function getAvailableTimezonesSorted(firstTimezoneInArr: string) {
  const availableTz = [
    'America/Santiago',
    'America/Argentina/Cordoba',
    'America/Punta_Arenas',
    'America/Bahia_Banderas',
    'America/Cancun',
    'America/Chihuahua',
    'America/Ciudad_Juarez',
    'America/Ensenada',
    'America/Hermosillo',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Merida',
    'America/Mexico_City',
    'America/Monterrey',
    'America/Ojinaga',
    'America/Santa_Isabel',
    'America/Tijuana',
    'Mexico/BajaNorte',
    'Mexico/BajaSur',
    'Mexico/General',
    'UTC',
  ];

  const allTimezones = moment.tz.names().filter((tz) => availableTz.includes(tz));

  allTimezones.sort((a, b) => {
    if (a === firstTimezoneInArr && b === 'UTC') {
      return -1;
    }
    if (b === firstTimezoneInArr && a === 'UTC') {
      return 1;
    }
    if (a === firstTimezoneInArr) {
      return -1;
    }
    if (b === firstTimezoneInArr) {
      return 1;
    }
    if (a === 'UTC') {
      return -1;
    }
    if (b === 'UTC') {
      return 1;
    }
    return a.localeCompare(b);
  });
  return allTimezones;
}

function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getTimezoneOffset(timezone: string): number {
  const date = new Date();
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
  const offsetMinutes = (tzDate.getTime() - utcDate.getTime()) / 60000;
  return offsetMinutes / 60;
}


function getTimezoneOffsetStr(timezone: string): string {
  const offset = getTimezoneOffset(timezone);
  if (offset < 0) {
    return `GMT${offset}`;
  }
  else if (offset > 0) {
    return `GMT+${offset}`;
  }
  return `GMT`;
}


export { getAvailableTimezonesSorted, getBrowserTimezone, getTimezoneOffset, getTimezoneOffsetStr };
